import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import find from 'lodash/find';
import { withRouter } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import some from 'lodash/some';
import filter from 'lodash/filter';
import { withStyles } from '@material-ui/core/styles';
import SketchOrderStatusChip from "../SketchOrderStatusChip/SketchOrderStatusChip";
import { allSketchOrderStatuses } from "../../lib/sketchOrderStatuses";
import withMobileDialog from '@material-ui/core/withMobileDialog';

const style = () => ({
    dialogContent: {
        minWidth: 300,
    },
    organizationChipWrapper: {
        display: 'inline',
        padding: 8,
    },
    selectStatusWrapper: {
        paddingBottom: 16,
    }
});

export class StatusSketchOrderFilterDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStatuses: this.getSelectedStatus(),
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            const selectedStatuses = this.getSelectedStatus();
            this.setState({
                selectedStatuses,
            })
        }
    }

    // get initial selected statuses
    getSelectedStatus = () => {
        const queryParams = queryString.parse(this.props.location.search);
        const { statusIds } = queryParams;

        if (!statusIds) {
            return [];
        }

        if (!Array.isArray(statusIds)) {
            const statuses = [];
            const status = find(allSketchOrderStatuses, ['id', parseInt(statusIds, 10)]);
            statuses.push(status);
            return statuses;
        }

        const statuses = [];
        statusIds.forEach((id) => {
            const status = find(allSketchOrderStatuses, ['id', parseInt(id, 10)]);
            statuses.push(status);
        });

        return statuses;
    };

    renderAvailableStatuses = (sketchOrderStatus) => (
        <ListItem key={sketchOrderStatus.id} button onClick={() => this.addStatus(sketchOrderStatus)}>
            <ListItemText primary={sketchOrderStatus.status} />
        </ListItem>
    );

    renderSelectedStatuses = (sketchOrderStatus) => (
        <div key={sketchOrderStatus.id} className={this.props.classes.organizationChipWrapper}>
            <SketchOrderStatusChip status={sketchOrderStatus.status} onDelete={() => this.removeFilter(sketchOrderStatus)}/>
        </div>
    );

    addStatus = (status) => {
        const { selectedStatuses } = this.state;
        selectedStatuses.push(status);
        this.setState({ selectedStatuses });
    };

    applyFilter = async () => {
        this.props.onApplyClick(this.state.selectedStatuses);
    };

    removeFilter = (status) => {
        const { selectedStatuses } = this.state;
        const updateStatuses = filter(selectedStatuses, (s) => {
            return status.id !== s.id;
        });
        this.setState({ selectedStatuses: updateStatuses });
    };

    filterAvailableStatuses = (status) => {
        return !some(this.state.selectedStatuses, status);
    };

    render() {
        const filteredAvailableStatues = allSketchOrderStatuses.filter(this.filterAvailableStatuses);

        return (
            <Dialog open={this.props.open} fullScreen={this.props.fullScreen}>
                <DialogTitle>
                    Filter By Status
                </DialogTitle>
                <DialogContent className={this.props.classes.dialogContent}>
                    <List>
                        <div className={this.props.classes.selectStatusWrapper}>
                            {this.state.selectedStatuses.map(this.renderSelectedStatuses)}
                        </div>
                        {filteredAvailableStatues.map(this.renderAvailableStatuses)}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onDismissClick}>
                        Dismiss
                    </Button>
                    <Button onClick={this.applyFilter} color="secondary">
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

StatusSketchOrderFilterDialog.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
    open: PropTypes.bool,
    onDismissClick: PropTypes.func.isRequired,
    onApplyClick: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        dialogContent: PropTypes.string.isRequired,
        organizationChipWrapper: PropTypes.string.isRequired,
        selectStatusWrapper: PropTypes.string.isRequired,
    }).isRequired,
};

StatusSketchOrderFilterDialog.defaultProps = {
    open: false,
    selectedStatuses: [],
};

export default withRouter(withMobileDialog()(withStyles(style)(StatusSketchOrderFilterDialog)));
